import TableSkeleton from '../TableSkeleton/TableSkeleton'

import './TableDataSetSkeleton.css'

export default function TableDataSetSkeleton() {
  return (
    <div id="table-data-set" className="table-data-set-skeleton skeleton-mode">
      <header className="container">
        <h2>
          <span className="icon icon-table" />
          <span className="skeleton-pulse text-block" />
        </h2>
        <section className="wrapper">
          <div className="skeleton-pulse subtitle" />
          <div className="skeleton-pulse subtitle" />
        </section>
      </header>
      <div className="table-wrapper">
        <TableSkeleton />
      </div>
    </div>
  )
}
